<ion-header>
  <ion-toolbar class="no-safe-area-top">
    <ion-buttons slot="start">
      <ion-button (click)="cancelChanges()" class="clear-btn">{{
        "flight.airline_modal.cancel" | translate
      }}</ion-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="confirmChanges()" class="clear-btn">{{
        "flight.airline_modal.done" | translate
      }}</ion-button>
    </ion-buttons>
  </ion-toolbar>
  <ion-toolbar>
    <ion-searchbar
      mode="ios"
      placeholder="{{
        'flight.airline_modal.search_by_airline_code_or_name' | translate
      }}"
      (keyup.enter)="filterAirlineListOnEnter($event)"
      (ionInput)="filterAirlineList($event)"
    ></ion-searchbar>
    <ion-progress-bar
      *ngIf="airlineList?.length < 1"
      type="indeterminate"
    ></ion-progress-bar>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-no-padding ion-no-margin">
  <ion-list class="ion-list-transparent-bg-color">
    <ion-item
      *ngFor="let item of airlineList"
      class="ion-no-padding ion-no-margin fs-3 ion-item-transparent-bg-color"
    >
      <!-- <ion-label
        class="font500 ion-padding-horizontal ion-label-primary-text-color"
        ></ion-label
      > -->
      <ion-checkbox
        label-placement="start"
        class="primary-checkbox ion-padding-start checkbox"
        [value]="item"
        [checked]="isChecked(item)"
        (ionChange)="checkboxChange($event)"
        aria-label="airline"
        >{{ item?.airportName || item?.airlineName }}</ion-checkbox
      >
    </ion-item>
  </ion-list>
  <no-data
    *ngIf="noData && page === 1 && airlineList.length === 0"
    componentHeight="70%"
  ></no-data>

  <ion-infinite-scroll (ionInfinite)="getNextPage($event)">
    <ion-infinite-scroll-content> </ion-infinite-scroll-content>
  </ion-infinite-scroll>
</ion-content>
